export const CANCEL_BIG_STAKE_REQUEST = 'CANCEL_BIG_STAKE_REQUEST';
export const SUCCESS_BIG_STAKE_REQUEST_CANCEL = 'SUCCESS_BIG_STAKE_REQUEST_CANCEL';
export const FAILURE_BIG_STAKE_REQUEST_CANCEL = 'FAILURE_BIG_STAKE_REQUEST_CANCEL';



// WEBPACK FOOTER //
// ./js/actions/BigStakeRequest.js